export default __webpack_public_path__ + "static/media/Opposites01_15.90698316.png";